import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { Milestones } from './milestone.model';

@Component({
  selector: 'cs-milestone-approval',
  standalone: false,
  templateUrl: './milestone-approval.component.html',
  styleUrls: ['./milestone-approval.component.scss']
})
export class MilestoneApprovalComponent implements OnInit, OnDestroy {
  public milestones: Array<Milestones>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;
  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getMilestones()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.milestones = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: Milestones): void {
    this.router.navigate(['/crm/customers/milestone-approval/approval'], {
      queryParams: { milestoneRequestId: request.milestoneRequestId }
    });
    this.closeTodo.emit();
  }
}
